import SavedSearchIcon from '@apps-common/ui-icons/SavedSearch.jsx';

export default SavedSearchIcon;
